import { render, staticRenderFns } from "./copyParentDescription.vue?vue&type=template&id=8718836a&scoped=true"
import script from "./copyParentDescription.vue?vue&type=script&lang=js"
export * from "./copyParentDescription.vue?vue&type=script&lang=js"
import style0 from "./copyParentDescription.vue?vue&type=style&index=0&id=8718836a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8718836a",
  null
  
)

export default component.exports